<div class="ordering-conditions-field truncate">
  <mp-param-wrapper class="mp-param-wrapper--horizontal ordering-conditions-field__wrapper" [label]="label()">
    <mp-param class="mp-param--inline ordering-conditions-field__value" [value]="value()" suffix="€" />
  </mp-param-wrapper>

  <div class="ordering-conditions-field__suffix">
    <ng-content />
  </div>
</div>
